import { useMutation } from '@tanstack/react-query';
import { getApiUrl, handleFetchResponse } from '../shared/utils/api';

export function useUpdateSimulation({ token = '' }) {
  const mutation = useMutation({
    mutationKey: ['update-simulation', token],
    mutationFn: async (params) => {
      const data = await handleFetchResponse(
        fetch(getApiUrl('energia-solar/v2/simulation/update'), {
          method: 'PUT',
          body: JSON.stringify(params),
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }),
      );
      return data;
    },
  });

  return mutation;
}
